<template id="total-stats-component">
  <div :class="[{'is-loading':ui.loading}, 'TotalStats']">
    <div
      id="DashboardHome"
      class="DashboardStats"
    >
      <div class="Dashboard-count Dashboard-countMainCount">
        <span class="DashboardStats-icon">
          <img
            src="../../../../images/user-icon.svg"
            alt="user icon"
          >
        </span>
        <div class="DashboardStats-stat">
          <a
            :href="results.allTimeStudents.url"
            :title="results.allTimeStudents.label"
          >
            <span class="DashboardStats-count">{{ results.allTimeStudents.value | commas }}</span>
          </a>
          <span class="DashboardStats-label">
            {{ results.allTimeStudents.label }}
          </span>
        </div>
        {{ results.studentsAddedInThePastXDays }}
        <div
          v-if="results.studentsAddedInThePastXDays.value > 0 && showPastXDaysResults"
          class="DashboardStats-new"
        >
          <a
            :href="results.studentsAddedInThePastXDays.url"
            :title="results.studentsAddedInThePastXDays.label"
          >
            <span class="Dashboard-newCount">
              <span class="DashboardStats-icon icon-arrow-up" />
              +{{ results.studentsAddedInThePastXDays.value | commas }}
            </span>
          </a>
          <span class="DashboardStats-label">
            {{ results.studentsAddedInThePastXDays.label }}
          </span>
        </div>
      </div>

      <div class="Dashboard-count">
        <span class="DashboardStats-icon">
          <img
            src="../../../../images/interaction-icon.svg"
            alt="interaction"
          >
        </span>
        <div class="DashboardStats-stat">
          <a
            :href="results.allTimeInteractions.url"
            :title="results.allTimeInteractions.label"
          >
            <span class="DashboardStats-count">
              {{ results.allTimeInteractions.value | commas }}
            </span>
          </a>
          <span class="DashboardStats-label">
            {{ results.allTimeInteractions.label }}
          </span>
        </div>
        <div
          v-if="results.interactionsAddedInThePastXDays.value > 0 && showPastXDaysResults"
          class="DashboardStats-new"
        >
          <a
            :href="results.interactionsAddedInThePastXDays.url"
            :title="results.interactionsAddedInThePastXDays.label"
          >
            <span class="Dashboard-newCount">
              <span class="DashboardStats-icon icon-arrow-up" />
              +{{ results.interactionsAddedInThePastXDays.value | commas }}
            </span>
          </a>
          <span class="DashboardStats-label">
            {{ results.interactionsAddedInThePastXDays.label }}
          </span>
        </div>
      </div>
      <div class="Dashboard-count">
        <span class="DashboardStats-icon">
          <img
            src="../../../../images/star-icon.svg"
            alt="star"
          >
        </span>
        <div class="DashboardStats-stat">
          <a
            :href="results.allTimeFavouriteStudents.url"
            :title="results.allTimeFavouriteStudents.label"
          >
            <span class="DashboardStats-count">
              {{ results.allTimeFavouriteStudents.value | commas }}
            </span>
          </a>
          <span class="DashboardStats-label">
            {{ results.allTimeFavouriteStudents.label }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CommonOperations from '../../../mixins/common-operations';
import LocalCopy from '../../../lang/en.json';

export default {
  mixins: [CommonOperations],
  props: {
    getDataUrl: {
      type: String,
      required: true,
      default: '',
    },
  },
  data() {
    return {
      showPastXDaysResults: true,
      results: {
        allTimeStudents: {
          url: '',
          label: '',
          value: 0,
        },
        studentsAddedInThePastXDays: {
          url: '',
          label: '',
          value: 0,
        },
        allTimeInteractions: {
          url: '',
          label: '',
          value: 0,
        },
        interactionsAddedInThePastXDays: {
          url: '',
          label: '',
          value: 0,
        },
        allTimeFavouriteStudents: {
          url: '',
          label: '',
          value: 0,
        },
      },
      ui: {
        loading: false,
      },
    };
  },
  beforeMount() {
    this.getTotalStats();
  },

  mounted() {
    this.$bus.$on('filterData', (event) => {
      this.getTotalStats(this.$_commonOperations_filterDataByDate(event));
    });
  },
  methods: {
    getTotalStats(filters) {
      const params = (typeof filters !== 'undefined') ? filters : null;
      this.showPastXDaysResults = (typeof filters === 'undefined');
      this.$_commonOperations_getDataNew(this.getDataUrl, { params })
        .then((response) => {
          this.ui.loading = false;
          const {
            allTimeStudents,
            studentsAddedInThePastXDays,
            allTimeInteractions,
            interactionsAddedInThePastXDays,
            allTimeFavouriteStudents,
          } = response.data;

          this.results.allTimeStudents = allTimeStudents;
          this.results.studentsAddedInThePastXDays = studentsAddedInThePastXDays;
          this.results.allTimeInteractions = allTimeInteractions;
          this.results.interactionsAddedInThePastXDays = interactionsAddedInThePastXDays;
          this.results.allTimeFavouriteStudents = allTimeFavouriteStudents;
        })
        .catch(() => {
          this.ui.loading = false;
          this.$_commonOperations_emitMessage(LocalCopy.flashMessage.errors.genericError, 'error');
        });
    },
  },
};
</script>
